export const CEO_DECISIONS_VIDEO =
  "https://drive.google.com/file/d/1BKoTLmrcYTsbYNXhUczKuTK3tA8l1yw5/preview";
export const PRODUCT_DEVELOPMENT_DECISIONS_VIDEO =
  "https://drive.google.com/file/d/177R-3Wcg2Htu27i8QbdjDpdV0mih4_mX/preview";
export const PRODUCT_MARKETING_DECISIONS_VIDEO =
  "https://drive.google.com/file/d/1LEAn7WxSACTftRoV1FlJtzAt49g47u_k/preview";
export const OPERATIONS_DECISIONS_VIDEO =
  "https://drive.google.com/file/d/1-3_OGPYDvE5d9d70d4jHlDyOTAetSUQ4/preview";
export const FINANCE_DECISIONS_VIDEO =
  "https://drive.google.com/file/d/1djbq2B5qQdnzmLP0b2zVPT-WTGM10cQ_/preview";



// WEBPACK FOOTER //
// ./src/data/videos-links.js